export class FullDetailsError extends Error {
  returnExtraDetails = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(m: any, errorExtraParam: any) {
    super(m);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, FullDetailsError.prototype);
    this.returnExtraDetails = errorExtraParam;
  }

  getExtraDetails() {
    return this.returnExtraDetails;
  }
}
